import React from 'react';
import { FormControl, RadioGroup, FormControlLabel, Radio, Grid, Typography } from '@material-ui/core';

const NumberSelector = ({ label, name, value, options, onChange }) => {
  const stringValue = value !== undefined && value !== null ? value.toString() : null;

  return (
    <Grid item xs={12}>
      <Typography variant="subtitle1">{label}:</Typography>
      <FormControl fullWidth>
        <RadioGroup row>
          {options.map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio />}
              checked={stringValue === option}
              onChange={onChange}
              label={option}
              name={name}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Grid>
  );
};

export default NumberSelector;
